export const dataUrlToFile = (dataUrl: string, filename: string): File => {
  const [header, base64Data] = dataUrl.split(",");
  const mimeMatch = header?.match(/:(.*?);/);
  if (!mimeMatch || !base64Data) {
    throw new Error("Invalid data URL");
  }

  const mime = mimeMatch[1];
  const binary = atob(base64Data);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }

  return new File([bytes], filename, { type: mime });
};
